//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PartFamily.js";
import "../no/NXObject.js";
let d=[[[0,"IsOptional",0,0],[0,"IsRequired",0,0],[0,"Name",0,0],[0,"Type",0,0],[0,"Value",0,0],[0,"Version",0,0]],[],[]];
SPLM.PartFamily.FamilyAttribute = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PartFamily.FamilyAttribute";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PartFamily.FamilyAttribute.AttrType = Object.freeze({
    "Text" : "Text", "Numeric" : "Numeric", "Integer" : "Integer", "Double" : "Double", "String" : "String", "Part" : "Part", "Name" : "Name", "Instance" : "Instance", "Expression" : "Expression", "Mirror" : "Mirror", "Density" : "Density", "Feature" : "Feature", "Mass" : "Mass", "Material" : "Material", "Cofm" : "Cofm", "Color" : "Color", "Undefined" : "Undefined"});

export default SPLM;